import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api-client';

export function useActiveAnnouncements(params?: { programId?: string }) {
  return useQuery({
    queryKey: ['announcements', 'active', params],
    queryFn: () =>
      apiClient.announcements.listActive({
        targetAudience: 'PARTICIPANT_ONLY',
        programId: params?.programId,
      }),
    refetchInterval: 1000 * 60 * 10, // 10 minutes; tab kembali fokus tetap menyegarkan
  });
}

export function useAnnouncement(id: string) {
  return useQuery({
    queryKey: ['announcements', id],
    queryFn: () => apiClient.announcements.get(id),
    enabled: !!id,
  });
}
